<template>
  <div class="password-box">
    <div class="input">
      <el-input
        class="btn-form"
        maxlength="11"
        placeholder="请输入手机号"
        v-model="loginForm.mobile"
        clearable
      ></el-input>
    </div>
    <div class="input yanzm">
      <el-input
        class="btn-form"
        maxlength="6"
        placeholder="短信验证码"
        @keyup.enter.native="loginHandler"
        v-model="loginForm.smsCode"
      ></el-input
      ><el-button
        @click="sendYanzm"
        :disabled="yanzmDisabled"
        class="sendYanzm"
        type="text"
        >{{ yanzmStr }}</el-button
      >
    </div>
    <div class="viewDetail">
      我已阅读并同意 <secrect-control></secrect-control>
    </div>
    <div class="btns">
      <el-button type="primary" @click="loginHandler"
        >登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</el-button
      >
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/untils/validate'
import SecrectControl from '@/components/secrect'
import { LOGIN_API,REPORT_API } from "@/api.js";
export default {
  props: ['role'],
  data() {
    return {
      loginForm: {
        mobile: '',
        smsCode: '',
        randomStr: '',
        ticket: '',
      },
      confirm: {},
      yanzmDisabled: false,
      yanzmTime: 60,
      yanzmStr: '发送验证码',
    }
  },
  components:{SecrectControl},
  methods: {
    sendMsmHandler() {
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号！')
        return
      }
      let post = {
        type: 1,
        ...this.loginForm,
      }
      let url = `${REPORT_API}/api/account/smscode`
      if (this.role == 1) {
        url = `${LOGIN_API}/customer/api/smscode`
      }
      this.$axios.post(url, post).then((res) => {
        if (this.role == 1) {
          if (res.data.errno == 0) {
            this.setTimer()
          } else {
            this.$message.error(res.data.errmsg)
          }
        } else {
          if (res.data.code == 0) {
            this.setTimer()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    setTimer() {
      this.$message.success('短信验证码发送成功！')
      this.yanzmDisabled = true
      this.yanzmTime = 60
      window.loginTimer ? window.clearInterval(window.loginTimer) : null
      window.loginTimer = window.setInterval(() => {
        this.yanzmTime--
        if (this.yanzmTime < 0) {
          this.yanzmDisabled = false
          window.clearInterval(window.loginTimer)
          this.yanzmStr = '发送验证码'
          return
        }
        this.yanzmStr = '验证码（' + this.yanzmTime + '秒）'
        console.log(this.yanzmStr)
      }, 1000)
    },
    callback(res) {
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if (res && res.ret === 0) {
        this.loginForm.randomStr = res.randstr
        this.loginForm.ticket = res.ticket
        this.sendMsmHandler()
      }
    },
    sendYanzm() {
      if (!isMobile(this.loginForm.mobile)) {
        this.$message.error('亲，手机号格式不正确，请重试！')
        return
      }
      var captcha1 = new TencentCaptcha('2012913766', this.callback)
      captcha1.show()
    },
    loginHandler() {
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号、密码！')
        return
      }
      if (!this.loginForm.smsCode) {
        this.$message.error('请输入短信验证码！')
        return
      }
      let post = this.loginForm
      if (this.role == '1') {
        // for c
        this.$axios
          .post(`${LOGIN_API}/customer/api/userSmsLogin`, post)
          .then((res) => {
            if (res.data.errno == 0) {
              this.$message.success('登录成功！')
              this.$cookies.set(
                'client_token',
                JSON.stringify({
                  token: res.data.result,
                  mobile: this.loginForm.mobile,
                }),
                0
                // 60 * 60 * 12
              )
              this.$axios.defaults.headers.common['authorization'] =
                res.data.result
              this.$store.dispatch('setLogin', true)
              this.$emit('close')
              location.reload()
            } else {
              this.$message.error(res.data.errmsg)
            }
          })
      } else {
        // for b
        this.$axios
          .post(
            `${REPORT_API}/api/account/userSmsLogin`,
            this.loginForm
          )
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data) {
                if (res.data.data.finish == 0) {
                  //没有完善
                  this.$message.success('登录成功，请继续完善信息！')
                  const hr_token = JSON.stringify({
                    token: res.data.data.kao_token,
                    finish: 0,
                    mobile: this.loginForm.mobile,
                  })
                  document.cookie =
                    'hr_token=' +
                    hr_token +
                    '; max-age=' +
                    60 * 60 * 12 +
                    '; path=/;'
                  this.$router.push('/register/compInfo')
                } else {
                  this.$message.success('登录成功！')
                  const hr_token = JSON.stringify({
                    token: res.data.data.kao_token,
                    finish: 1,
                    mobile: this.loginForm.mobile,
                  })
                  document.cookie =
                    'hr_token=' +
                    hr_token +
                    '; max-age=' +
                    60 * 60 * 12 +
                    '; path=/;'
                  //TODO: vue-cookie always encode cookie
                  //this.$cookies.set("kao_token", res.data.data, 60 * 60 * 12, '/', '.acmcoder.com')
                  document.cookie =
                    'kao_token="' +
                    res.data.data.kao_token +
                    '"; max-age=' +
                    60 * 60 * 12 +
                    '; path=/; domain=.acmcoder.com;'
                  location.href = 'https://kao.acmcoder.com/b/'
                }
              }
            } else {
              this.$message.error(res.data.message)
            }
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.password-box {
  width: 315px;
  margin: 20px auto 0px;
  .viewDetail{
    margin-top: 10px;
    font-size: 14px;
  }
  .input {
    padding: 10px 0px;
  }
  .yanzm {
    position: relative;
    .sendYanzm {
      position: absolute;
      top: 10px;
      right: 15px;
      color: #29bdb9;
      &.is-disabled {
        color: #999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/model/login-msm.vue